// extracted by mini-css-extract-plugin
export default {"movie":"Movie_movie__-uU6d","movie__container":"Movie_movie__container__4rUXC"};